import { _get, _getAxios, _getAxiosWithoutInterceptor } from "./serviceMain";

export function getUserProfile() :Promise<any> {

  const url = '/v3/account/profile';

  return _getAxios(url, "GET_PROFILE_TIME", "profile");

};

export function getUserProfileWithoutInterceptor() :Promise<any> {

  const url = '/v3/account/profile';

  return _getAxiosWithoutInterceptor(url, "GET_PROFILE_TIME", "profile");

};